export default __webpack_public_path__ + "static/media/552.36bbadc9.gif";